import "../scss/styles.scss";
import PageCommon	from "./pages/PageCommon.js";
import PageDefault	from "./pages/PageDefault.js";
import PageGeneric from "./pages/PageGeneric.js";
import PageCreateAccount from "./pages/PageCreateAccount.js";
import PageVini from "./pages/PageVini.js";
import PageProduct from "./pages/PageProduct.js";
import PageSearch from "./pages/PageSearch.js";

import ServiceManager from "./3x1010/services/ServiceManager.js";

export default class App {
	static factory(cls) {
		return new App.classes[cls]();
	}
}

// PAGINE
App.classes = {
	PageCommon, PageDefault, PageGeneric,
	PageCreateAccount, PageVini, PageProduct,
	PageSearch
};

// ALTRE CLASSI ESPORTATE ESPLICITAMENTE
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon; 